import { asyncScope } from "./utils";
import type { NavigationRaw } from "..";
import type { NexusHandler } from "../../nexus/function/function.types";
import { defineContext, historyPatched } from "./history.client";
import { navigateCrossDocument } from "./navigation.client";
import { baseLocation } from "./location";

const log = asyncScope.scope("navigate");

/**
 *
 */
export const navigate: NexusHandler<NavigationRaw["navigate"]> = async (
  urlOrString = "",
  o = {},
) => {
  const { history: navigationType = "push", state, info } = o;
  log.debug("Navigation request:", navigationType, "for:", urlOrString, "with options", o);

  /*                                                       */
  const nextUrl = new URL(urlOrString, baseLocation.origin);
  /*                                                  */
  if (nextUrl.hash.length < 2) nextUrl.hash = "";

  /*                                          */
  if (navigationType === "document") return navigateCrossDocument(nextUrl, info);

  /*                                                                */
  const method = (await historyPatched)[`${navigationType}State`];
  if (!method) return false;

  /*                                                           */
  log.info("Navigate to", nextUrl.href, "as", navigationType, "with state", state);
  method.call(defineContext({ ...o }), state, "", nextUrl);
  return true;
};
